import React, { useEffect, useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import CandidateProfile from "../candidateProfile";
import CandidateInterviewHistory from "../candidateInterviewHistory";
import { Button, Divider } from "antd";
import "./candidateDescription.scss";
import ResumeAnalysisNew from "../resumeAnalysisNew";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useResumeStore from "../../store/resume.store";
import SkillMatrixTableSelectable from "../SkillMatrixTableSelectable";

function CandidateDescription() {
  const { handleProfileBackBtn } = useOutletContext();
  const { value, resumeID,view,id } = useParams();
  const [currentView, setCurrentView] = useState(view);   //can be only profle or interview_history
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const {getSpecificApplicationByJD,selectedApplication,selectedProfileResume,
    getProfileResumeDetails,
    resetUpdateFlagSpecific,
    updateFlagSpecific } = useResumeStore();

  //call in the beginning or whenever it changes.
  useEffect(() => {
    if(updateFlagSpecific == false){
      getSpecificApplicationByJD(value, resumeID);
      getProfileResumeDetails(value,resumeID)
    }
  }, []);

  useEffect(() => {
    if(updateFlagSpecific){
      resetUpdateFlagSpecific()
      getSpecificApplicationByJD(value, resumeID);
      getProfileResumeDetails(value,resumeID)
    }
  }, [updateFlagSpecific]);

    //dont render till the respose come
  if (selectedApplication === null || selectedProfileResume === null) return;
  const skillMatrixTitles = [
    "Select",
    "S. No.",
    "Skills/Questions",
    "Relevant Experience",
    "Self Rating",
  ];


  const skillMatrixData = selectedApplication?.skillmatrix?.map((item, idx) => {
    return {
      select: "",
      id: idx,
      skill: item.skill
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      mentionedexp: item?.isvalid ? item?.mentionedexp : "--",
      selfrating: item?.isvalid ? item?.selfrating : "--",
    };
  });

  return (
    <>
      <div className="candidate-description-wrapper">
        <div className="candidate-description-buttons-wrapper">
          <Button
            className="candidate-description-back-button"
            onClick={handleProfileBackBtn}
          >
            <ArrowLeftOutlined />
          </Button>
          <Button
            className={`candidate-description-btn ${
              currentView === "profile" && "candidate-description-btn-active"
            }`}
            onClick={(e) => {
              setCurrentView("profile");
            }}
          >
            Profile
          </Button>
          {
               userDetails.productsignon.toLowerCase().includes("qhrflow")?
              <>
                <Button
                  className={`candidate-description-btn ${
                    currentView === "interview_history" &&
                    "candidate-description-btn-active"
                  }`}
                  onClick={(e) => {
                    setCurrentView("interview_history");
                  }}
                >
                  Interview History
                </Button>
                <Button
                  className={`candidate-description-btn ${
                    currentView === "Resume Analysis" &&
                    "candidate-description-btn-active"
                  }`}
                  onClick={(e) => {
                    setCurrentView("Resume Analysis");
                  }}
                >
                  Resume Analysis
                </Button>
                <Button
                  className={`candidate-description-btn ${
                    currentView === "skill_matrix" &&
                    "candidate-description-btn-active"
                  }`}
                  onClick={(e) => {
                    setCurrentView("skill_matrix");
                  }}
                >
                  Skill Matrix
                </Button>              
              </>
              :<></>
          }
        </div>
        <Divider />
        {currentView === "profile" ? (
          <CandidateProfile jdID={value} resumeID={resumeID}/>
        ) : currentView === "interview_history" ? (
          <CandidateInterviewHistory jdID={value} rID={resumeID} />
        ) : currentView === "Resume Analysis" ? (
          <ResumeAnalysisNew jdID={value} rID={resumeID} />
        ) : currentView === "skill_matrix" ? (
          <SkillMatrixTableSelectable
            titleList={skillMatrixTitles}
            data={skillMatrixData}
            qhjid={value}
            candidateSkillMatrixPage={true}
            resumeID={selectedApplication?.qhrid}
            columnWidth={"50px 50px 2fr 1fr 1fr"}
          />
        ) : null}
      </div>
    </>
  );
}

export default CandidateDescription;
